// src/index.js
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { TransactionsProvider } from './contexts/TransactionsContext'
import { WalletProvider } from './contexts/WalletContext'

import './styles/globals.css'
import './styles/animations.css'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <AuthProvider>
                <TransactionsProvider>
                    <WalletProvider>
                        <App />
                    </WalletProvider>
                </TransactionsProvider>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>
)
